/** 관리자(60+)는 원문, 고객/멤버는 간단한 한국어 안내 */

const MEMBER_MESSAGE_RULES: Array<{ test: RegExp; message: string }> = [
  {
    test: /롱텀케어 로그인이 불가|CERT_LTCS_UNSUPPORTED/,
    message: '이 공동인증서는 롱텀케어 로그인이 불가합니다.',
  },
  {
    test: /인증서가 만료|인증서 유효기간|유효기간이 만료|CERT_EXPIRED/,
    message: '인증서가 만료되어 자동가져오기를 할 수 없습니다. 새 인증서를 등록한 뒤 다시 시도해 주세요.',
  },
  { test: /m_code|mCode/i, message: '기관 정보를 확인할 수 없습니다.' },
  { test: /유효하지 않은 요청 유형|cmq_type|caion_ltcs_/i, message: '요청을 처리할 수 없습니다.' },
  { test: /기관을 찾을 수 없/i, message: '기관 정보를 찾을 수 없습니다.' },
  { test: /bizGubun|yearMonth|사업구분|연월/i, message: '사업구분 또는 조회 연월을 확인해 주세요.' },
  { test: /동일한 요청|이미 대기|처리 중입니다/i, message: '같은 요청이 이미 진행 중입니다.' },
  {
    test: /요청이 많아|요청할 수 없|MACRO_BUSY|수용|과부하/i,
    message: '지금 요청이 많아 롱텀케어에서 자료를 요청할 수 없습니다. 잠시 후 다시 시도해 주세요.',
  },
  { test: /워커|worker|LtcRequest|폴링/i, message: '자료 수집 프로그램 실행 여부를 확인해 주세요.' },
  // 롱텀케어 로그인·홈페이지 접속 장애 (기술 상세 비노출)
  {
    test: /롱텀케어 접속에 오류|loginForm|LOGIN_FAILED|LOGIN_TIMEOUT|CERT_DIALOG|로그인 실패|로그인 시간|인증서 대화|홈페이지 점검|시스템 점검|maintenance|메뉴 검색창|업무포털|Chrome CDP|net::ERR|Navigation timeout|페이지 로드|포털 렉/i,
    message: '롱텀케어 접속에 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
  },
  { test: /타임아웃|timeout|시간 초과/i, message: '처리 시간이 초과되었습니다. 잠시 후 다시 시도해 주세요.' },
  { test: /Network Error|ECONNREF|EADDR|ENOTFOUND|socket/i, message: '서버와 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.' },
  { test: /권한|access|denied|forbidden|401|403/i, message: '요청 권한이 없습니다.' },
  { test: /찾을 수 없|not found|404/i, message: '요청 정보를 찾을 수 없습니다.' },
  { test: /취소할 수 없/i, message: '지금은 요청을 취소할 수 없습니다.' },
  { test: /재실행|retry/i, message: '요청을 다시 실행할 수 없습니다.' },
];

const TECHNICAL_PATTERN =
  /(?:caion_[a-z_]+|cmq_[a-z_]+|m_code|bizGubun|yearMonth|Error:|Exception|undefined|null is not|\b[A-Z][a-z]+(?:Error|Exception)\b)/i;

function stripStatusSuffix(message: string): string {
  return message.replace(/\s*\(\d{3}\)\s*$/, '').trim();
}

function looksTechnical(message: string): boolean {
  if (TECHNICAL_PATTERN.test(message)) return true;
  if (/^[A-Za-z0-9_.:\s()-]+$/.test(message) && /[A-Za-z]{5,}/.test(message)) return true;
  return false;
}

function matchMemberMessage(message: string): string | null {
  for (const rule of MEMBER_MESSAGE_RULES) {
    if (rule.test.test(message)) return rule.message;
  }
  return null;
}

export interface FormatUserFacingErrorOptions {
  /** true: 관리자용 원문 표시 */
  verbose?: boolean;
  fallback?: string;
  status?: number | string;
}

export function formatUserFacingError(
  raw: string | null | undefined,
  options: FormatUserFacingErrorOptions = {}
): string {
  const fallback = options.fallback || '처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
  if (!raw?.trim()) return fallback;

  const cleaned = stripStatusSuffix(raw.trim());

  if (options.verbose) {
    const status = options.status;
    return status ? `${cleaned} (${status})` : cleaned;
  }

  const mapped = matchMemberMessage(cleaned);
  if (mapped) return mapped;

  if (looksTechnical(cleaned)) return fallback;

  return cleaned;
}

export function formatApiErrorMessage(
  error: any,
  options: FormatUserFacingErrorOptions = {}
): string {
  const status = error?.response?.status;
  const raw =
    error?.response?.data?.message ||
    error?.message ||
    options.fallback ||
    '처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';

  return formatUserFacingError(raw, {
    ...options,
    status: options.verbose ? status : undefined,
    fallback: options.fallback,
  });
}
